import React from "react";

interface HowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HowItWorksModal: React.FC<HowItWorksModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  const steps = [
    {
      number: 1,
      title: "Browse Products",
      description:
        "Select the items you'd like to donate by browsing through our available products.",
    },
    {
      number: 2,
      title: "Choose Donation Frequency & add to cart",
      description:
        "Select how often you'd like to donate a product and add it to your cart.",
    },
    {
      number: 3,
      title: "Confirm Donation",
      description:
        "Review your selections and tap 'Confirm Donation' to proceed with your contribution.",
    },
    {
      number: 4,
      title: "Scan QR Code/Click Link",
      description:
        "Scan the QR code with your mobile payment app or click the link to complete the donation securely.",
    },
    {
      number: 5,
      title: "Complete Payment",
      description:
        "Complete the payment on your mobile device to confirm your donation.",
    },
  ];

  return (
    <div className="how-it-works-modal-overlay" onClick={onClose}>
      <div className="how-it-works-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>How It Works</h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-content">
          {/* <div className="video-section">
            <iframe
              width="100%"
              height="200"
              src={`https://www.youtube.com/embed/${config.youtube.videoId}`}
              title="How It Works - Instamandi Donation"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div> */}
          {steps.map((step) => (
            <div key={step.number} className="step">
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorksModal;
